// Notion Links
export const careersUrl = `https://iterative.notion.site/DVC-ai-is-Hiring-852cb978129645e1906e2c9a878a4d22`
export const privacyPolicyUrl = `https://iterative.notion.site/Privacy-Cookie-Policy-edbce9b3b3d14f26950b7dca617b2033`
export const bugBountyUrl = `https://iterative.notion.site/Bug-Bounty-Program-c9c7719be9fc43fb941be156cd94d881`

// Social Links
export const twitterUrl = `https://x.com/datachain_ai`
export const youtubeUrl = `https://www.youtube.com/channel/UC37rp97Go-xIX3aNFVHhXfQ`
export const linkedinUrl = `https://www.linkedin.com/company/datachain-ai/`
export const discordUrl = `https://discord.com/invite/dvwXA2N`

// dvc.org Links
export const dvcUrl = `https://dvc.org`
export const dvcDocsUrl = `${dvcUrl}/doc`
export const dvcGetStartedUrl = `${dvcUrl}/doc/start`
export const dvcCommunityUrl = `${dvcUrl}/community`
export const dvcSupportUrl = `${dvcUrl}/support`
export const dvcUserGuidePrivacyUrl = `${dvcUrl}/doc/user-guide/privacy`

// datachain Links
export const datachainUrl = `https://github.com/iterative/datachain`

// datachain docs links
export const datachainDocsUrl = `https://docs.datachain.ai`
export const datachainQuickStartUrl = `https://docs.datachain.ai/quick-start/`

// Studio links
export const studioUrl = `https://studio.datachain.ai`
export const studioSignInUrl = `${studioUrl}/auth/sign-in`
export const studioSignUpUrl = `${studioUrl}/auth/sign-up`
export const studioScheduleOverviewUrl = `https://schedule.iterative.ai/studio-overview`
// Studio API links
export const studioContactUsApi = `${studioUrl}/api/contacts`

// cml.dev Links
export const cmlUrl = `https://cml.dev`

// mlem.ai Links
export const mlemUrl = `https://mlem.ai`

// Vscode links
export const vscodeUrl = `https://marketplace.visualstudio.com/items?itemName=Iterative.dvc`

// github links
export const githubIterativeUrl = `https://github.com/iterative`
export const githubDvcUrl = `https://github.com/iterative/dvc`
export const githubDatachainUrl = `https://github.com/iterative/datachain`

// Learn links
export const learnWithUsUrl = `https://learn.iterative.ai/`

export const downloadUrlPrefix = `https://static.iterative.ai/branding`

// GDPR links
export const enpoUrl = `https://edpo.com`
export const enpoGdprDataRequestUrl = `https://edpo.com/gdpr-data-request`

// Static links
export const soc2Type1ReportPdf = `https://static.iterative.ai/iterative-inc-soc2-type1-report.pdf`
export const soc2Type2Dec2024ReportPdf = `https://static.iterative.ai/iterative-inc-soc2-type2-report-dec-2024.pdf`
export const soc2LetterToCustomersPdf = `https://static.iterative.ai/iterative-inc-security-as-a-company-value.pdf`

// Mailchimp
export const mailchimpDatachainCourseWaitlsitUrl = `https://dvc.us10.list-manage.com/subscribe/post?u=a08bf93caae4063c4e6a351f6&amp;id=396584b7ae&amp;f_id=002945e4f0`
